import { services as company } from './company'
import { services as course } from './course'
import { services as group } from './group'
import { services as domainShift } from './shift'
import { services as ambience } from './ambience'
import { services as hour } from './hour'
import { services as workTime } from './worktime'
import { services as signature } from './signature'
import { services as access } from './access'
import { services as grid } from './grid'
import { services as communication } from './communication'
import { services as occurrence } from './occurrence'
import { services as integration } from './integration'
import { services as dynamics } from './dynamics'
import { services as teacher} from './teacher'
import { services as agent } from './agent'
import { services as arp } from './arp'
import { services as learningPath } from './learning-path'
import { services as cenarioCatalogo } from './cenario-catalogo'

export default {
    ...company,
    ...group,
    ...course,
    ...ambience,
    ...hour,
    ...workTime,
    ...signature,
    ...access,
    ...grid,
    ...communication,
    ...occurrence,
    ...integration,
    ...teacher,
    //Quando não tem subdomínio, não precisa de chaves
    domainShift,
    ...dynamics,
    ...agent,
    ...arp,
    ...learningPath,
    ...cenarioCatalogo,
}